module.exports = __webpack_public_path__ + "img/Online Claim.2044cb5.png";